export enum BlockDisplayTypeEnum {
    TWIG = 'TWIG',
    ONLINE = 'ONLINE',
};
